import React from 'react'
import { Link } from 'react-router-dom'
import { AppleIcon, AndroidIcon } from './SignupSvgs'
import { t } from 'translation'
import { connect } from 'react-redux'

const SignupStepFour = ({ alwaysOnWelcomeVideo }) => {
  const redirectPath = alwaysOnWelcomeVideo ? `/welcome` : '/indication-select'

  return (
    <div className="auth_block">
      <h1 className="section_title v4_mod color_mod offset_v4_mod decor_mod center_mod">
        {t('signup.WELCOME_TO_MUSIC_CARE')}
      </h1>
      <div className="auth_block_descr decor_mod offset_mod center_lvl_mod">
        {t('signup.ACCESS_TO_ALL_SESSIONS')}
      </div>
      <div className="phone_system_buttons offset_mod">
        <a
          className="phone_system_buttons_item btn_download"
          href={t('links.APP_APPLE_STORE')}
          target="_blank"
          rel="noreferrer noopener"
        >
          <div className="btn_download_icon">
            <AppleIcon className="icon size_mod" />
          </div>
          {t('signup.DOWNLOAD_ON_IOS')}
        </a>
        <a
          className="phone_system_buttons_item btn_download"
          href={t('links.APP_GOOGLE_STORE')}
          target="_blank"
          rel="noreferrer noopener"
        >
          <div className="btn_download_icon">
            <AndroidIcon className="icon size_mod" />
          </div>
          {t('signup.DOWNLOAD_ON_ANDROID')}
        </a>
      </div>
      <div className="btn_wrap center_lvl_mod">
        <Link className="btn_link" to={redirectPath}>
          {t('signup.BROWSER_PLAY')}
        </Link>
      </div>
    </div>
  )
}

const mapStateToProps = ({ auth: { attributes } }) => ({
  alwaysOnWelcomeVideo: attributes?.permissions?.features?.alwaysOnWelcomeVideo,
})

export default connect(mapStateToProps)(SignupStepFour)
